/**
 * This object defines constant values for Google Analytics events
 */
export const GA4Constants = {
  EVENTS: {
    ADD_MEDIA: 'awc_add_media',
    ADD_MEDIA_TO_CART: 'awc_add_media_to_cart',
    ADD_PAYMENT_INFO: 'add_payment_info',
    ADD_SHIPPING_INFO: 'add_shipping_info',
    ADD_TO_CART: 'add_to_cart',
    /* begin_checkout event is emitted when the user selects "checkout" */
    BEGIN_CHECKOUT: 'begin_checkout',
    /* start_checkout event is emitted when the one page checkout app loads */
    START_CHECKOUT: 'awc_start_checkout',
    CONFIRM_PAYMENT: 'awc_confirm_payment',
    CLEAR_ECOMMERCE: 'clear_ecommerce',
    ERROR: 'error',
    /* initiate_checkout event is emitted when the user selects "checkout" */
    INITIATE_CHECKOUT: 'awc_initiate_checkout',
    ADD_PAYMENT_SELECTION: 'awc_payment_selection',
    NONE: 'none',
    PURCHASE: 'purchase',
    REMOVE_FROM_CART: 'remove_from_cart',
    SELECT_ITEM: 'select_item',
    SIGN_UP: 'sign_up',
    TRANSACTION_COMPLETE: 'transaction_complete',
    VIEW_CART: 'view_cart',
    VIEW_ITEM: 'view_item',
    VIEW_ITEM_LIST: 'view_item_list',
    ADD_MEMBER: 'awc_add_member',
    ADD_PERSONALIZATION: 'awc_add_personalization',
    ADD_MEMBER_COMPLETE: 'awc_add_member_complete',
  },
  EVENT_TYPES: {
    CHECKOUT_ASSIGN_ERROR: 'checkout assign error',
    CHECKOUT_PERSONALIZE_ERROR: 'checkout personalize error',
    CHECKOUT_MEDIA_ERROR: 'checkout media error',
    CHECKOUT_SHIPPING_ERROR: 'checkout shipping error',
    CHECKOUT_PAYMENT_ERROR: 'checkout payment error',
    CHECKOUT_CONFIRM_ERROR: 'checkout confirm error',
  },
  ITEM_LISTS: {
    CATEGORY_PRODUCTS: { ID: 'category_products', NAME: 'Category Products' },
    CROSS_SELL: { ID: 'cross_sell', NAME: 'Cross Sell' },
    RELATED_PRODUCTS: { ID: 'related_products', NAME: 'Related Products' },
    ADD_ONS: { ID: 'add_on', NAME: 'Add On' },
    DIRECT: { ID: 'direct', NAME: 'Direct' },
    MEDIA: { ID: 'media', NAME: 'Media' },
    FENCED_VOUCHER: { ID: 'fenced_voucher_product', NAME: 'Fenced Voucher Product' }
  },
  DEFAULT_STORE_PLATFORM: 'aspenware_platform',
  DEFAULT_STORE_VERSION: 'aspenware_commerce',
  DEFAULT_AFFILIATION: 'Aspenware Store',
  DEFAULT_CURRENCY: 'USD',
  DEFAULT_PAYMENT_TYPE: 'UNKNOWN',
  // If we can't determine how a product was accessed, it might be a deep link.  We'll use "other"
  DEFAULT_LIST_ID: 'unknown',
  DEFAULT_LIST_NAME: 'Unknown',
  DEFAULT_CATEGORY: 'UNKNOWN',
  DEFAULT_SUBCATEGORY: 'UNKNOWN',
  DEFAULT_UNKNOWN: 'UNKNOWN',
  DEFAULT_UNDEFINED: 'UNDEFINED',
  LOCAL_CART_ID: 'AXCOMMERCE_CART',
  // Use for Fenced Voucher products with /s/v/ route
  FENCED_VOUCHER_CATEGORY: { Name: 'Fenced Voucher Category', Id: 0 },
}
